module.exports = __webpack_public_path__ + "static/assets/dd70a6d9adb5f52d0cbd0115887691eb.png";